import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { prop } from '@ipfabric/utils/fp/prop';
import type { TableCommandFactory } from 'components/Table/model/TableModel';

export const toggleSelectFilteredTableRows: TableCommandFactory =
  (cmdContext) => async () => {
    const originalState = cmdContext.getState().allRowsSelectState;
    if (originalState === 'pending') {
      stumble('cannot run multiple selection toggle operations at once');
      return;
    }
    const { loadRowIdsForSelectAll } = cmdContext.getState();
    if (loadRowIdsForSelectAll === undefined) {
      stumble('function for loading all row ids was not provided');
      return;
    }
    const loadFn =
      loadRowIdsForSelectAll === 'fromData'
        ? () =>
            cmdContext
              .getState()
              .data.map(prop(cmdContext.getState().rowIdField as never))
        : loadRowIdsForSelectAll;
    const add = originalState === 'unchecked';

    cmdContext.updateState((draft) => {
      draft.allRowsSelectState = 'pending';
    });
    try {
      const allRowIds = await loadFn(!add);
      cmdContext.updateState((draft) => {
        draft.allRowsSelectState = add ? 'checked' : 'unchecked';
        const operation = add ? 'add' : 'delete';
        if (allRowIds === null) {
          draft.selectedRows.clear();
        } else {
          for (const id of allRowIds) {
            draft.selectedRows[operation](id);
          }
        }
      });
    } catch (e) {
      cmdContext.updateState((draft) => {
        draft.allRowsSelectState = add ? 'unchecked' : 'checked';
      });
      throw e;
    }
  };
